import { makeStyles } from '@material-ui/core/styles';
import crewBlockStyles from '../components/CrewBlock/styles';

export default makeStyles(crewBlockStyles);
